import type { ChildrenFilter } from '@api';
import { Icon } from '@design';
import * as Radix from '@radix-ui/react-dropdown-menu';
import { FilterOption } from '@terminal/components/update-filter-options/updateFilterOptions';
import React, { useState } from 'react';

import styles from './Filter.module.scss';
import { Option } from './Option';

export type ChildFilterProps = {
  filter: ChildrenFilter;
  activeOptions: FilterOption[];
  onClick: (option: FilterOption) => void;
};

export const ChildFilter = ({
  filter,
  activeOptions,
  onClick,
}: ChildFilterProps) => {
  const [open, setOpen] = useState(false);
  const activeOption =
    activeOptions.find(o => o.childName === filter.name) ||
    filter.options.find(f => f.key === filter.default) ||
    filter.options[0];

  const isChecked = (optKey?: string) => activeOption.key === optKey;

  const isFilterOptionActive = (option: FilterOption) => {
    return (
      !option.include ||
      !activeOptions.length ||
      option.include.some(key => activeOptions.some(o => o.key === key))
    );
  };

  return (
    <Radix.Sub open={open} onOpenChange={o => setOpen(o)}>
      <Radix.SubTrigger className={styles.subTrigger}>
        <span className={styles.subTriggerLabel}>{activeOption.name}</span>
        <Icon
          iconName="ChevronLightRight"
          size={12}
          fillColor="var(--icon-primary)"
        />
      </Radix.SubTrigger>
      <Radix.Portal>
        <Radix.SubContent className={styles.subMenuContent} sideOffset={30}>
          <p className={styles.menuTitleText}>{filter.name}</p>
          <Radix.Group />
          {filter.options.filter(isFilterOptionActive).map(o => {
            const option = { ...o, childName: filter.name };

            return (
              <Option
                data-testid={option.key}
                key={option.name}
                option={option}
                isChecked={isChecked(option.key)}
                handleClick={() => {
                  onClick(option);
                  setOpen(o => !o);
                }}
              />
            );
          })}
        </Radix.SubContent>
      </Radix.Portal>
    </Radix.Sub>
  );
};
